// Tiny language picker used by codemod-converted isAr ternaries.
// For new strings, prefer using react-i18next's t() with keys in src/i18n/locales/*.json.
import i18n from "@/i18n";

/**
 * Pick a string based on the active language.
 * - Backward compatible: existing tr(ar, en, fr) calls behave identically —
 *   accounting error messages (SD001–SD021) and printed documents are unaffected.
 * - Optional `ur`: when omitted, Urdu falls back to English silently.
 */
export function tr(ar: string, en: string, fr: string, ur?: string): string {
  const lang = (i18n.language || "ar").toLowerCase();
  if (lang.startsWith("ar")) return ar;
  if (lang.startsWith("fr")) return fr;
  if (lang.startsWith("ur")) return ur ?? en;
  return en;
}
